import { Box } from '@mui/material'
import { useAtom } from 'jotai'
import { selectedCraftingInnerTabAtom, selectedTierAtom } from '@/atoms'
import type { SkillTierIndex } from '@/types'
import { CraftingRecipeModeTabBar } from '@/components/ui/CraftingRecipeModeTabBar'
import { TierList } from '@/components/ui/TierList'

export function TierSidebarPanel() {
  const [innerTab, setInnerTab] = useAtom(selectedCraftingInnerTabAtom)
  const [selectedTier, setSelectedTier] = useAtom(selectedTierAtom)

  return (
    <Box
      sx={{
        gridArea: 'sidebar',
        borderRight: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ px: 1, pt: 1, pb: 0.75, borderBottom: '1px solid', borderColor: 'divider' }}>
        <CraftingRecipeModeTabBar value={innerTab} onChange={setInnerTab} />
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', p: 1 }}>
        <TierList
          selectedTier={selectedTier}
          onSelect={(tier: SkillTierIndex | null) => setSelectedTier(tier)}
        />
      </Box>
    </Box>
  )
}
